var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMembersIcon = function SvgMembersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.001 8.167a4.167 4.167 0 0 1 4.167 4.166v5H4.835v-5A4.167 4.167 0 0 1 9 8.167m-5.593 2.505a5.8 5.8 0 0 0-.233 1.375l-.007.286v5h-2.5v-3.75a2.917 2.917 0 0 1 2.6-2.9zm11.187 0a2.92 2.92 0 0 1 2.74 2.911v3.75h-2.5v-5c0-.577-.084-1.135-.24-1.661M3.585 5.667a2.083 2.083 0 1 1 0 4.166 2.083 2.083 0 0 1 0-4.166m10.833 0a2.083 2.083 0 1 1 0 4.166 2.083 2.083 0 0 1 0-4.166m-5.417-5a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666"
  })));
};
export default SvgMembersIcon;